module.exports = __webpack_public_path__ + "img/maestro-card.95d6c3b8.png";